import React from 'react';
import styles from './Breadcrumbs.module.scss';
import { Link } from './link';
import SchemaScript from './schemaScript';
const getCleanTitle = (item) => {
    // we don't care about query strings or anchors for title
    const title = item.split('?')[0].split('#')[0].replace(/-/g, ' ');
    return title.charAt(0).toUpperCase() + title.slice(1);
};
export const createBreadcrumbs = (path) => {
    const pathWithoutParams = path.split('?')[0];
    const breadcrumbItems = path.split('/').filter((item) => item);
    return pathWithoutParams
        .split('/')
        .filter(Boolean)
        .map((item, index) => {
        const title = getCleanTitle(item);
        const path = '/' +
            breadcrumbItems
                .slice(0, index + 1)
                .join('/')
                .toLowerCase();
        return { title, path };
    });
};
const Breadcrumbs = ({ crumbs, CustomLink, analytics, schemaScript = false, }) => (<>
    {schemaScript && <SchemaScript breadcrumbs={crumbs}/>}
    <ol className={styles.breadcrumbs}>
      {crumbs.map((crumb, index) => index !== crumbs.length - 1 ? (<li key={crumb.path}>
            <Link breadcrumb={crumb} route={crumbs
            .slice(0, index + 1)
            .map((crumb) => crumb.title.toLowerCase())
            .join('>')} CustomLink={CustomLink} analytics={analytics}/>
          </li>) : (<li key={crumb.path} className={styles.currentPage}>
            {crumb.title}
          </li>))}
    </ol>
  </>);
export default Breadcrumbs;
